var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramFeesAndInterest64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./FeesAndInterest64*",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "FeesandInterest64"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram",
    transform: "translate(13.000000, 8.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-13",
    fill: "#FFFFFF",
    points: "0 48 0 0 27 0 38 11 38 48"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Rectangle",
    fill: "#FFCC00",
    points: "37.595459 12 26 12 26 0.400878906"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Focus",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 27,
    cy: 27,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Focus-Copy",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 36,
    cy: 39,
    r: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bottom",
    fill: "#4F4C4D",
    transform: "translate(31.192388, 33.192388) rotate(-45.000000) translate(-31.192388, -33.192388) ",
    x: 19.1923882,
    y: 32.1923882,
    width: 24,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramFeesAndInterest64);
export default __webpack_public_path__ + "static/media/pictogramFeesAndInterest64.d53b133b4dc21aa8166130bed6706306.svg";
export { ForwardRef as ReactComponent };